import React, { useCallback, useEffect, useRef, useState } from 'react';

import Skeleton from 'react-loading-skeleton';

import { useDispatch, useSelector } from 'react-redux';
import ProductItem from '../ProductItem';

import { StoreState } from '../../store/createStore';
import { customerFavoriteList } from '../../store/modules/auth/actions';
import {
  findProductRequest,
  setProductFilter,
} from '../../store/modules/product/actions';
// import { ProductData } from '../../store/modules/product/types';
import {
  Container,
  ContainerLoading,
  ContainerProducts,
  ContainerProductsResult,
  ContainerProductsResultRow,
  MessageProductNotFound,
  Root,
  ScrollSentinel,
} from './styles';
import { layout } from '../../../package.json';

const calculateLimit = (): number => {
  const desktopBreakpoint = parseInt(layout.desktop, 10);
  const windowWidth = window.innerWidth;
  
  if (windowWidth < desktopBreakpoint) {
    return 24;
  }
  
  const desktopWideBreakpoint = parseInt(layout.desktop_wide, 10);
  if (windowWidth >= desktopWideBreakpoint) {
    return 48;
  }
  
  return 24;
};

const ProductList: React.FC = () => {
  const dispatch = useDispatch();
  const [limit, setLimit] = useState<number>(calculateLimit());
  const {
    loading, products, response: { currentPage, lastPage },
  } = useSelector(
    (state: StoreState) => state.product,
  );
  const { multistoreSelected } = useSelector(
    (state: StoreState) => state.parameter,
  );
  const { user } = useSelector((state: StoreState) => state.auth);
  const sentinelRef = useRef<HTMLDivElement>(null);
  const isLoadingMoreRef = useRef(false);

  // const fetchProducts = useCallback((filtersAditional?: any) => {
  //   const currentLimit = calculateLimit();
  //   setLimit(currentLimit);
    
  //   const filtersWithLimit = {
  //     ...filtersAditional,
  //     limit: currentLimit,
  //   };
    
  //   if (filtersWithLimit) {
  //     dispatch(setProductFilter(filtersWithLimit));
  //   }
  //   dispatch(findProductRequest());
  // }, [dispatch]);

  const handleNextFindProduct = useCallback(() => {
    try {
      if (currentPage < lastPage && !loading && !isLoadingMoreRef.current) {
        isLoadingMoreRef.current = true;
        const currentLimit = calculateLimit();
        dispatch(setProductFilter({
          page: currentPage + 1,
          limit: currentLimit,
        }));
        dispatch(findProductRequest());
      }
    } catch (err) {
      console.error('Error loading more products:', err);
      isLoadingMoreRef.current = false;
    }
  }, [currentPage, lastPage, loading, dispatch]);

  useEffect(() => {
    if (user.data.id) {
      dispatch(customerFavoriteList());
    }
  }, [dispatch, user.data.id]);

  // useEffect(() => {
  //   setIsAlreadyCalled(false);
  // }, [setIsAlreadyCalled, multistoreSelected]);

  useEffect(() => {
    const handleResize = () => {
      const newLimit = calculateLimit();
      if (newLimit !== limit) {
        setLimit(newLimit);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [limit]);

  // useEffect(() => {
  //   if (!IsAlreadyCalled &&
  //     !loading &&
  //     products.length === 0) {
  //     fetchProducts();
  //     setIsAlreadyCalled(true);
  //   }

  // }, [fetchProducts, loading, products, IsAlreadyCalled]);

  useEffect(() => {
    if (!loading) {
      isLoadingMoreRef.current = false;
    }
  }, [loading]);

  useEffect(() => {
    const sentinel = sentinelRef.current;

    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && currentPage < lastPage && !loading && !isLoadingMoreRef.current) {
          handleNextFindProduct();
        }
      },
      {
        root: null,
        rootMargin: '100px',
        threshold: 0.1,
      }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, [currentPage, lastPage, loading, handleNextFindProduct]);

  return (
    <Root>
    <Container>
      {
        !loading && multistoreSelected && products.length === 0 ? (
          <ContainerProducts><MessageProductNotFound>Produtos indisponíveis para essa loja</MessageProductNotFound></ContainerProducts>
        ) : (
          <>
            <ContainerProducts>
              <ContainerProductsResult>
                <ContainerProductsResultRow>
                  {products &&
                    products.map((product, index) => (
                      <ProductItem
                        id={`product-list-${index + 1}`}
                        key={product.product_id}
                        product={product}
                        width={1800}
                        height={260}
                        loading={loading}
                      />
                    ))}
                </ContainerProductsResultRow>
              </ContainerProductsResult>
            </ContainerProducts>
            {loading && (
              <ContainerLoading>
                <Skeleton
                  style={{ marginBottom: '16px', width: '100%', display: 'block' }}
                  duration={2}
                  width="98%"
                  height={35}
                />
              </ContainerLoading>
            )}
            {currentPage < lastPage && (
              <ScrollSentinel ref={sentinelRef} />
            )}
          </>
        )
      }
    </Container>
    </Root>
  );
};

export default ProductList;
